import { PlusOutlineIcon } from '@carboncopyco/icons';
import { DemoOrangeIllustration } from '@carboncopyco/illustrations';
import { Button, EmptyView, TextBase } from '@carboncopyco/ui';
import { WorkspacePageCreateMenu } from './WorkspacePageCreateMenu';

export const WorkspacePageEmptyState = () => {
  return (
    <EmptyView
      illustration={<DemoOrangeIllustration />}
      title="No items yet"
      message={
        <div className="flex flex-col items-center gap-5 ">
          <TextBase label="Once you'll create an item, it will appear here" />
          <WorkspacePageCreateMenu
            asChild
            triggerElement={
              <Button
                blue
                link
                label="Create new"
                leftIcon={<PlusOutlineIcon />}
              />
            }
            location="empty_workspace"
          />
        </div>
      }
    />
  );
};
